import type { ProjectScope } from '../sync/project-scope.ts';
import {
    enqueueStructuredEntityWrite,
    type StructuredEntityWriteRegistration,
} from '../sync/structured-entity-write.ts';

type LightingWriteOptions = {
    actorId?: string;
};

const FOLLOW_SPOT_WRITE_REGISTRATION: StructuredEntityWriteRegistration = {
    feature: 'department_tracking',
    capability: 'EDIT_LIGHTING',
    conflictPrefix: 'followSpots',
    allowedKinds: ['patchEntity', 'deleteEntity'],
    authErrorMessage: 'Authentication required to preserve lighting project writes',
};

export async function deleteFollowSpot(
    scope: ProjectScope,
    followSpotId: string,
    options: LightingWriteOptions = {}
): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: FOLLOW_SPOT_WRITE_REGISTRATION,
        entityId: followSpotId,
        kind: 'deleteEntity',
        payload: { id: followSpotId },
        actorId: options.actorId,
    });
}
